import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import useMST1030_R01Store from "./Store_MST1030_R01";
import useUiuxStore from "src/store/useUiuxStore";
import { Content_MST1030_R01 } from "./Content_MST1030_R01";
import { SearchSection_MST1030_R01 } from "./SearchSection_MST1030_R01";
import { Table_MST1030_R01 } from "./Table_MST1030_R01";
import { AgGridReact } from "ag-grid-react";
import { useRef } from "react";
import { MST1030_R01Dto } from "./Dto_MST1030_R01";

export const Container_MST1030_R01 = () => {
    const { initData } = useMST1030_R01Store();
    const { setMessage } = useUiuxStore();

    const { fetchData, handleExcelClick, handleTabChange } = Content_MST1030_R01({
        setMessage,
    });

    const gridRef = useRef<AgGridReact<MST1030_R01Dto>>(null);

    return (
        <div className="content-container">
            <Actionbar
                onFetchClick={fetchData}
                onCreateClick={() => {}}
                onDeleteClick={() => {}}
                onSaveClick={() => {}}
                onExcelClick={handleExcelClick}
                onInitClick={initData}
            />
            <SearchSection_MST1030_R01 fetchData={fetchData} />
            <div className="flex-1 flex">
                <div className="w-full h-full flex flex-col p-[12px] gap-[12px]">
                    <Table_MST1030_R01
                        gridRef={gridRef}
                        onTabChange={handleTabChange}
                    />
                </div>
            </div>
            <Message />
        </div>
    );
};
